import { Route } from '@angular/router';
import { KeycloakUserRole } from '@libs/shared/interface/enum';
import { InitialDataResolver } from '@sprint-backoffice/app/app.resolvers';
import { AuthGuard } from '@sprint-backoffice/app/core/auth/auth-guard.service';
import { LayoutComponent } from '@sprint-backoffice/app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('@sprint-backoffice/app/pages/landing/home/home.routes'),
      },
    ],
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'on-boarding',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/manager-on-boarding/manager-on-boarding.routes'
          ),
      },
    ],
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      {
        path: 'manager-dashboard',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/manager-dashboard/manager-dashboard.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'food-card-review',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/food-card-review/food-card-review.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'manager-complaint',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/manager-complaint-list/manager-complaint-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'manager-assessment',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/manager-assessment-list/manager-assessment-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'food-card',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-card-list/food-card-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'food',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-list/food-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'food-brand',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-brand-list/food-brand-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'food-vendor',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-vendor-list/food-vendor-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'food-serving-unit',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-serving-unit-list/food-serving-unit-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'food-category',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-category-list/food-category-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'food-category-type',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-category-type-list/food-category-type-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'food-card-failure-reason-type',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-card-failure-reason-type-list/food-card-failure-reason-type-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'food-cooking-mode',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-cooking-mode-list/food-cooking-mode-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'supplement',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/supplement-list/supplement-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'supplement-brand',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/supplement-brand-list/supplement-brand-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'supplement-vendor',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/supplement-vendor-list/supplement-vendor-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'supplement-serving-unit',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/supplement-serving-unit-list/supplement-serving-unit-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.SeniorManager,
            KeycloakUserRole.JuniorManager,
          ],
        },
      },
      {
        path: 'supplement-category',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/supplement-category-list/supplement-category-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'supplement-category-type',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/supplement-category-type-list/supplement-category-type-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'exercise',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/exercise-list/exercise-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'exercise-body-part',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/exercise-body-part-list/exercise-body-part-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'exercise-equipment',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/exercise-equipment-list/exercise-equipment-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'exercise-machine',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/exercise-machine-list/exercise-machine-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'exercise-category',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/exercise-category-list/exercise-category-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'exercise-target',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/exercise-target-list/exercise-target-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'expert-workspace',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/expert-workspace-list/expert-workspace-list.routes'
            ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'expert-office',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/expert-office-list/expert-office-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'expert-partner',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/expert-partner-list/expert-partner-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'manager',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/manager-list/manager-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'member',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/member-list/member-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'subscription-coupon-profile',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/subscription-coupon-profile-list/subscription-coupon-profile-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'subscription-coupon',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/subscription-coupon-list/subscription-coupon-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'credit-point-coupon-profile',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/credit-point-coupon-profile-list/credit-point-coupon-profile-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'credit-point-coupon',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/credit-point-coupon-list/credit-point-coupon-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'coupon-customer',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/coupon-customer-list/coupon-customer-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'coupon-cancellation-reason',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/coupon-cancellation-reason-list/coupon-cancellation-reason-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'expert-workspace-subscription-cancellation-reason',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/expert-workspace-subscription-cancellation-reason-list/expert-workspace-subscription-cancellation-reason-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'voice-of-customer',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/voice-of-customer-list/voice-of-customer-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'user-dictionary-entry',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/user-dictionary-entry-list/user-dictionary-entry-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'food-search-pinned-entry',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/food-search-pinned-entry-list/food-search-pinned-entry-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'exercise-search-pinned-entry',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/lists/exercise-search-pinned-entry-list/exercise-search-pinned-entry-list.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'admin-control-panel',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/admin-control-panel/admin-control-panel.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [KeycloakUserRole.Admin],
        },
      },
      {
        path: 'settings',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/manager-settings/manager-settings.routes'
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [
            KeycloakUserRole.Admin,
            KeycloakUserRole.JuniorManager,
            KeycloakUserRole.SeniorManager,
          ],
        },
      },
      {
        path: 'not-found',
        pathMatch: 'full',
        loadChildren: () =>
          import(
            '@sprint-backoffice/app/pages/error/error-not-found/error-not-found.routes'
          ),
      },
      {
        path: '**',
        redirectTo: 'not-found',
      },
    ],
  },
];
